export default __webpack_public_path__ + "static/barry-background-splash-45d812495d64b445f1d872224193f1fb.png";